import { TAttributeListType } from '@interfaces/assets/assetHistory';

import { ERadioColors } from '@enums/colors';
import { EAssetSiteA11yStatus, EPowerSupplyA11yStatus } from '@enums/map';

import { distanceTooltipMessages } from '@constants/common';
import { EProfileFields } from '../constants';

export const distanceOptions: Record<string, any> = {
	RED: {
		value: EPowerSupplyA11yStatus.red,
		label: distanceTooltipMessages.RED,
		color: ERadioColors.red,
	},
	AMBER: {
		value: EPowerSupplyA11yStatus.amber,
		label: distanceTooltipMessages.AMBER,
		color: ERadioColors.amber,
	},
	GREEN: {
		value: EPowerSupplyA11yStatus.green,
		label: distanceTooltipMessages.GREEN,
		color: ERadioColors.green,
	},
};

export const availabilityOptions: Record<string, any> = {
	RED: {
		value: EAssetSiteA11yStatus.red,
		label: distanceTooltipMessages.RED,
		color: ERadioColors.red,
	},
	AMBER: {
		value: EAssetSiteA11yStatus.amber,
		label: distanceTooltipMessages.AMBER,
		color: ERadioColors.amber,
	},
	GREEN: {
		value: EAssetSiteA11yStatus.green,
		label: distanceTooltipMessages.GREEN,
		color: ERadioColors.green,
	},
};

export const conditionsOptions: Record<string, any> = {
	true: {
		value: true,
		label: 'Yes',
	},
	false: {
		value: false,
		label: 'No',
	},
};

export const availabilityCards: TAttributeListType[] = [
	{
		title: 'Asset site access availability:',
		options: conditionsOptions,
		statusName: EProfileFields.isAvailable,
		detailsName: EProfileFields.assetAccessDetails,
		fileFieldName: EProfileFields.assetAccessDetailsFileIds,
	},
	{
		title: 'Special implementation issues exist:',
		options: conditionsOptions,
		statusName: EProfileFields.specialImplementationIssuesExist,
		detailsName: EProfileFields.specialImplementationIssueDetails,
		fileFieldName: EProfileFields.specialImplementationIssueDetailsFileIds,
	},
];

export const statusCards: TAttributeListType[] = [
	{
		title: 'Backhaul accessibility status:',
		options: distanceOptions,
		detailsName: EProfileFields.backhaulAccessibilityDetails,
		statusName: [EProfileFields.backhaulAccessibilityStatus, EProfileFields.name],
		fileFieldName: EProfileFields.backhaulAccessibilityDetailsFileIds,
	},
	{
		title: 'Power supply availability status:',
		options: distanceOptions,
		detailsName: EProfileFields.powerSupplyAvailabilityDetails,
		statusName: [EProfileFields.powerSupplyAvailabilityStatus, EProfileFields.name],
		fileFieldName: EProfileFields.powerSupplyAvailabilityDetailsFileIds,
	},
	{
		title: 'Asset site availability status:',
		options: availabilityOptions,
		detailsName: EProfileFields.assetSiteAvailabilityDetails,
		statusName: [EProfileFields.assetSiteAvailabilityStatus, EProfileFields.name],
		fileFieldName: EProfileFields.assetSiteAvailabilityDetailsFileIds,
	},
];
